<template>
    <div class="fe-full-screen-error">
        <span>{{ error.resultMessage }}</span>
    </div>
</template>

<script>
    export default {
        name: "FullScreenError",
        props: {
            error: {
                type: Object,
                required: true
            },
        },
    }
</script>

<style scoped>
    .fe-full-screen-error {
        text-align: center;
        top: 50%;
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        background-color: white;
        font-size: 15px;
        word-break: break-all;
        font-style: normal;
    }
</style>